import { useState, useRef, useCallback } from "react";
import { useMarketplaceCartService } from "@/services";
import {
  MarketplaceCartType,
  MarketplaceCartItemType,
  ProductCostItemType,
} from "@/schemas/index";

export function useShoppingCart() {
  const api = useMarketplaceCartService();
  const [marketplaceCartData, setMarketplaceCartData] =
    useState<MarketplaceCartType>();
  const currentPromiseFetchInit = useRef<any>();

  const fetchShoppingCart = () => {
    if (currentPromiseFetchInit.current) {
      return currentPromiseFetchInit.current;
    }

    currentPromiseFetchInit.current = api.fetchMarketplaceCart();
    currentPromiseFetchInit.current
      .then((marketplaceCartData: MarketplaceCartType) => {
        setMarketplaceCartData(marketplaceCartData);
      })
      .finally(() => {
        currentPromiseFetchInit.current = null;
      });

    return currentPromiseFetchInit.current;
  };

  const fetchRemoveItemCart = async (itemId: MarketplaceCartItemType["Id"]) => {
    return await api
      .fetchRemoveProduct(itemId)
      .then((marketplaceCartData: MarketplaceCartType) => {
        setMarketplaceCartData(marketplaceCartData);
      });
  };

  const fetchAddProductToCart = async (
    costId: ProductCostItemType["Id"],
    quantity?: number,
  ) => {
    return await api
      .fetchAddProductToCart(costId, quantity)
      .then((marketplaceCartData: MarketplaceCartType) => {
        setMarketplaceCartData(marketplaceCartData);
      });
  };

  const fetchIncreaseItemCart = useCallback(
    (itemId: MarketplaceCartItemType["Id"]) => {
      const item = (marketplaceCartData?.Items || []).find(
        (item) => itemId === item.Id,
      );

      if (!item) {
        throw Error("Item not found");
      }
      return api
        .fetchUpdateShoppingItemCart({
          Id: item.Id,
          CostId: item.CostId,
          Quantity: item.Count + 1,
        })
        .then((marketplaceCartData: MarketplaceCartType) => {
          setMarketplaceCartData(marketplaceCartData);
        });
    },
    [marketplaceCartData],
  );

  const fetchReduceItemCart = useCallback(
    (itemId: MarketplaceCartItemType["Id"]) => {
      const item = (marketplaceCartData?.Items || []).find(
        (item) => itemId === item.Id,
      );

      if (!item) {
        throw Error("Item not found");
      }

      return api
        .fetchUpdateShoppingItemCart({
          Id: item.Id,
          CostId: item.CostId,
          Quantity: item.Count - 1,
        })
        .then((marketplaceCartData: MarketplaceCartType) => {
          console.log(marketplaceCartData);
          setMarketplaceCartData(marketplaceCartData);
        });
    },
    [marketplaceCartData],
  );

  return {
    marketplaceCartCount: marketplaceCartData?.TotalQnt || 0,
    marketplaceCartData,

    fetchShoppingCart,
    fetchAddProductToCart,

    fetchRemoveItemCart,
    fetchReduceItemCart,
    fetchIncreaseItemCart,
  };
}
